import React, { useState, useRef, useEffect } from "react";
import { Table } from "antd";
import { Icon } from "@iconify/react";
import DelTableRowModal from "../../modals/delTableRowModal";
import { Select } from "antd";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CaseDetailModal from "../../modals/caseDetailModal";
import Button from "../../components/shared/button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getAllUsers } from "../../APIs/userAuthApi";
import secureLocalStorage from "react-secure-storage";
const Users = () => {
  const { t } = useTranslation();
  const { Option } = Select;
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const datePickerRef = useRef(null);
  const [isdelModalOpen, setIsdelModalOpen] = useState(false);
  const [iscaseDetailOpen, setiscaseDetailOpen] = useState(false);
  const [users, setUsers] = useState([]); 
  const [error, setError] = useState(""); 
  const loginData = secureLocalStorage.getItem("loginCredentials");

  console.log("users", users);

  useEffect(() => {
    getAllUsers(loginData?.token)
      .then((response) => {
        console.log("API Full Response:", response); // Debugging log
        console.log("Extracted Data:", response.data); // Debugging log
  
        setUsers(Array.isArray(response.data) ? response.data : []); //  Extracting data array
      })
      .catch((err) => {
        console.error("Error fetching users:", err);
        setError(err);
      });
  }, [loginData]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleIconClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setFocus();
    }
  };

  // const data = [
  //   {
  //     key: "1",
  //     name: "John Doe",
  //     email: "doe1234@gmail.com",
  //     dateJoined: "Mon Oct 7, 2024 11:30 am",
  //     totalUploads: "100",
  //     plan: "Basic",
  //   },
  //   {
  //     key: "2",
  //     name: "John Doe",
  //     email: "doe1234@gmail.com",
  //     dateJoined: "Mon Oct 7, 2024 11:30 am",
  //     totalUploads: "100",
  //     plan: "Basic",
  //   },
  //   {
  //     key: "3",
  //     name: "John Doe",
  //     email: "doe1234@gmail.com",
  //     dateJoined: "Mon Oct 7, 2024 11:30 am",
  //     totalUploads: "100",
  //     plan: "Basic",
  //   },
  //   {
  //     key: "4",
  //     name: "John Doe",
  //     email: "doe1234@gmail.com",
  //     dateJoined: "Mon Oct 7, 2024 11:30 am",
  //     totalUploads: "100",
  //     plan: "Basic",
  //   },
  //   {
  //     key: "5",
  //     name: "John Doe",
  //     email: "doe1234@gmail.com",
  //     dateJoined: "Mon Oct 7, 2024 11:30 am",
  //     totalUploads: "100",
  //     plan: "Basic",
  //   },
  //   {
  //     key: "6",
  //     name: "John Doe",
  //     email: "doe1234@gmail.com",
  //     dateJoined: "Mon Oct 7, 2024 11:30 am",
  //     totalUploads: "100",
  //     plan: "Basic",
  //   },
  // ];

  const columns = [
    {
      title: t("adminDashboard.users.name"),
      dataIndex: "username",  // Updated from "name" to "username"
      key: "username",
      render: (text) => <span className="text-[#000] font-medium">{text || "N/A"}</span>,
    },
    {
      title: t("adminDashboard.users.email"),
      dataIndex: "email",
      key: "email",
      render: (text) => <span className="text-[#000] font-medium">{text || "N/A"}</span>,
    },
    {
      title: t("adminDashboard.users.dateJoined"),
      dataIndex: "createdAt",  // Updated from "dateJoined" to "createdAt"
      key: "createdAt",
      render: (text) => (
        <span className="text-[#000] font-medium">
          {text ? new Date(text).toLocaleDateString() : "N/A"}
        </span>
      ),
    },
    {
      title: t("adminDashboard.users.totalUploads"),
      dataIndex: "totalUploads",  // This field is missing in API, keep it but handle undefined
      key: "totalUploads",
      render: (text) => <span className="text-[#000] font-medium">{text || "N/A"}</span>,
    },
    {
      title: t("adminDashboard.users.plan"),
      dataIndex: "plan",  // This field is missing in API, keep it but handle undefined
      key: "plan",
      render: (text) => <span className="light-blue-color font-medium">{text || "N/A"}</span>,
    },
    {
      title: t("adminDashboard.users.actions"),
      key: "actions",
      // render: ( ) => ( 
      render: (_, record) => ( 

        <div className="flex gap-[8px] items-center">
          <button
            className="bg-[#D3EFF4] text-secondary rounded-[47px] px-[15px] py-[5px] small font-poppins cursor-pointer"
            // onClick={() => navigate("/user-details/chat-history")}
            onClick={() => navigate("/user-details/chat-history", { state: { user: record } })}

          >
            {t("adminDashboard.users.details")}
          </button>
          <img src="../../assets/icons/block.png" alt="" className="cursor-pointer" />
        </div>
      ),
    },
  ];
  

  return (
    <>
      <div className="files-main py-[43px] flex flex-col gap-[35px]">
        <div className="top flex items-center justify-between">
          <h5 className="text-blue font-bold">{t("adminDashboard.users.title")}</h5>
          <Button
            text="Add New"
            className="button btn-blue !rounded-[29px] medium"
            height={45}
            width={137}
            img="line-md:plus"
            clr="white"
          />
        </div>
        <div className="bottom">
          <div className="filter-div bg-white rounded-t-[20px] gap-[20px] flex items-center md-m:flex-col max-sm:gap-[10px] justify-between py-[22px] pr-[20px] pl-[15px]">
            <div className="left-div gap-[20px] flex items-center max-sm:flex-col">
              <Icon
                icon="solar:filter-bold-duotone"
                color="#143A62"
                width={22}
                height={22}
                className="max-sm:hidden"
              />
              <div className="flex gap-[8px] items-center">
                <p className="small font-medium">{t("adminDashboard.users.category")}:</p>
                <Select
                  placeholder={t("adminDashboard.users.all")}
                  style={{ width: 148 }}
                  className="admin-dropdown"
                >
                  <Option value="Client Information">
                    {t("adminDashboard.users.clientInformation")}
                  </Option>
                  <Option value="Contract Management">
                    {t("adminDashboard.users.contractManagement")}
                  </Option>
                  <Option value="Evidence Management">
                    {t("adminDashboard.users.evidenceManagement")}
                  </Option>
                  <Option value="Incident Details">
                    {t("adminDashboard.users.incidentDetails")}
                  </Option>
                </Select>
              </div>
              <div className="flex gap-[8px] items-center">
                <p className="small font-medium">{t("adminDashboard.users.date")}:</p>
                <div className="flex items-center gap-[10px] rounded-[10px] p-[10px] border-[var(--stroke-weight-1,1px)] bg-[#F0F0F0]">
                  <DatePicker
                    selected={selectedDate}
                    onChange={handleDateChange}
                    className="text-[#8D8D8D] bg-transparent font-medium small font-montserrat"
                    dateFormat="MM/dd/yyyy"
                    ref={datePickerRef}
                  />
                  <Icon
                    icon="clarity:date-line"
                    className="text-gray-500 cursor-pointer"
                    onClick={handleIconClick}
                  />
                </div>
              </div>
            </div>
            <div className="py-[15px] flex items-center gap-[5px] border-b border-solid border-b-[#B8C0CB]">
              <input type="search" placeholder={t("adminDashboard.users.search")} />
              <Icon icon="si:search-line" color="#143A62" width={22} height={22} />
            </div>
          </div>
          <Table
            columns={columns}
            // dataSource={data}
            dataSource={users.length > 0 ? users : []}

            pagination={{
              position: ["bottomCenter"],
              pageSize: 6,
              itemRender: (current, type, originalElement) => {
                if (type === "prev") {
                  return (
                    <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                      <Icon icon="ep:arrow-left-bold" color="#143A62" />
                    </div>
                  );
                }
                if (type === "next") {
                  return (
                    <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                      <Icon icon="ep:arrow-right-bold" color="#143A62" />
                    </div>
                  );
                }
                return originalElement;
              },
              showSizeChanger: false,
            }}
            className="w-full admin-dashboardTables"
            scroll={{ x: "1000px" }}
          />
        </div>
      </div>
      <DelTableRowModal isdelModalOpen={isdelModalOpen} setIsdelModalOpen={setIsdelModalOpen} />
      <CaseDetailModal
        iscaseDetailOpen={iscaseDetailOpen}
        setiscaseDetailOpen={setiscaseDetailOpen}
      />
    </>
  );
};

export default Users;
